import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-form" }

import { IonSearchbar, IonIcon } from '@ionic/vue';
import { onMounted, ref } from 'vue';
import { useVModel } from '@vueuse/core';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import StorageService from "@/helpers/storageService";
import { EventNamesEnum } from '@/const/events';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchForm',
  props: {
    modelValue: {},
    placeholder: { default: '' },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any, { emit: __emit }) {

const { isDesktop } = useBreakpoint();

const props = __props;

const clear = () => {
  let filters = StorageService.getItem('filters', 'ss');
  if(filters?.search) {
    filters = {...filters, search: ''};
    StorageService.setItem('filters', filters, 'ss')
  }
  searchModel.value = '';
  emits(EventNamesEnum.OnClear);
};

const emits = __emit;

const searchModel = useVModel(props, 'modelValue', emits);

const searchBarRef = ref<typeof IonSearchbar | null>(null);

onMounted(() => {
  setTimeout(() => searchBarRef.value?.$el.setFocus());
  searchModel.value = props.modelValue
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonSearchbar), {
      modelValue: _unref(searchModel),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchModel) ? (searchModel).value = $event : null)),
      class: "search-form__control",
      "show-clear-button": "never",
      placeholder: _ctx.placeholder,
      ref_key: "searchBarRef",
      ref: searchBarRef,
      disabled: _ctx.disabled
    }, {
      default: _withCtx(() => [
        ((_unref(isDesktop) && _unref(searchModel)) || !_unref(isDesktop))
          ? (_openBlock(), _createBlock(_unref(IonIcon), {
              key: 0,
              class: "btn clear-btn",
              src: "assets/icon/cross-mark.svg",
              onClick: clear
            }))
          : _createCommentVNode("", true),
        (_unref(isDesktop) && !_unref(searchModel))
          ? (_openBlock(), _createBlock(_unref(IonIcon), {
              key: 1,
              class: "btn search-btn",
              src: "assets/icon/search.svg"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder", "disabled"])
  ]))
}
}

})